import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const reviews = [{
  name: 'Emily P.',
  location: 'Austin, TX',
  text: "My puppy Max can't get enough of this bowl! No more yogurt explosions on my kitchen floor. Game changer.",
  image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Liam R.',
  location: 'Seattle, WA',
  text: "Perfect for my senior dog, Bella. She can lick at her own pace, and I'm not cleaning broth off the walls anymore. Worth every penny.",
  image: 'https://images.unsplash.com/photo-1537151608828-ea2b11777ee8?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Sophia M.',
  location: 'Miami, FL',
  text: 'I was skeptical about the floating disc, but WOW. My hyperactive Lab actually calms down during treat time now. She licks for 15 minutes and then naps. This is magic.',
  image: 'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}];
export function Testimonials() {
  return <section className="py-16 bg-gray-50 rounded-3xl my-16" data-id="element-93">
      <div className="text-center mb-12" data-id="element-94">
        <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-95">
          Real Dog Parents, Real Results
        </h2>
        <div className="flex justify-center gap-1 text-[#FFD700] mb-2" data-id="element-96">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-current" data-id="element-97" />)}
        </div>
        <p className="text-gray-600" data-id="element-98">Rated 4.9/5 by 10,000+ Happy Customers</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-4 md:px-8" data-id="element-99">
        {reviews.map((review, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col" data-id="element-100">
            <div className="flex items-center gap-1 text-[#FFD700] mb-4" data-id="element-101">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-102" />)}
            </div>
            <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-103">
              "{review.text}"
            </p>
            <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-100" data-id="element-104">
              <img src={review.image} alt={review.name} className="w-10 h-10 rounded-full object-cover" data-id="element-105" />
              <div data-id="element-106">
                <div className="font-bold text-gray-900" data-id="element-107">{review.name}</div>
                <div className="text-xs text-gray-500" data-id="element-108">{review.location}</div>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}